import { NEWSLETTER_SERVICE } from "@/services/newsletter.service.js";

const state = {getNewsletterEmailOutput: {}};

const actions = {
    //
    getNewsletterEmail({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getNewsletterEmailRequest');

        NEWSLETTER_SERVICE.getNewsletterEmail(queryParams)
            .then(
                output => {
                    commit('getNewsletterEmailSuccess', output);
                },
                error => {
                    commit('getNewsletterEmailFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getNewsletterEmail
    getNewsletterEmailRequest(state) {
    },
    getNewsletterEmailSuccess(state, output) {
        state.getNewsletterEmailOutput = output;
    },
    getNewsletterEmailFailure(state) {
        state.getNewsletterEmailOutput = false;
    },
};

export const newsletter = {
    namespaced: true,
    state,
    actions,
    mutations
};